import React, { useEffect, useState } from "react";
import CompanySlotDays from "./CompanySlotDays";
import CompanySpecialSlot from "./CompanySpecialSlot";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { siteDetails } from "../../redux/api/dummyJson";
import { BASE_URL, URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const CompanySlotMain = ({ type }) => {
  const [activeTab, setActiveTab] = useState("week");
  const [days, setDays] = useState([...days_arr]);
  const [dates, setDates] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleCheckboxChange = (dayType) => {
    setSelectedDays((prev) => {
      if (prev.includes(dayType)) {
        return prev.filter((d) => d !== dayType);
      } else {
        return [...prev, dayType];
      }
    });
  };

  console.log("selectedDays", selectedDays);

  const handleTab = (days) => {
    setActiveTab(days);
    // setOption(null);
    // setDates([]);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const navigate = useNavigate();

  const location = useLocation();

  // const type = location?.state?.type;
  const createdAt = moment().format("DD-MM-YYYY");

  const [option, setOption] = useState(null);
  const [siteList, setSiteList] = useState([]);
  const [fileUpload, setFileUpload] = useState("");

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getDayList = (knf_company_site_id, currentDayIndex = 0) => {
    if (!type) {
      setOption(knf_company_site_id);
    }
    if (knf_company_site_id?.value) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", knf_company_site_id?.value);
      post(URL.DAY_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [...days_arr];
            let data = [...res?.data];
            let day_type = [1, 2, 3, 4, 5, 6, 7];
            data?.map((item) => {
              if (day_type?.includes(item?.type)) {
                let indexToReplace = day_type.findIndex(
                  (i) => i === item?.type,
                );
                temp[indexToReplace] = {
                  ...temp[indexToReplace],
                  toggle: item?.start_time && item?.end_time ? true : false,
                  start_time: item?.start_time
                    ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                    : "",
                  end_time: item?.end_time
                    ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                    : "",
                };
              }
            });

            // ✅ Use the currently active day index, not always the first
            const activeDay = temp[currentDayIndex];
            if (activeDay?.start_time && activeDay?.end_time) {
              const matchingDays = temp
                .filter(
                  (d) =>
                    d.type !== activeDay.type &&
                    d.start_time === activeDay.start_time &&
                    d.end_time === activeDay.end_time,
                )
                .map((d) => d.type);
              setSelectedDays(matchingDays);
            } else {
              setSelectedDays([]); // ✅ No time set = no checkboxes
            }

            setDays(temp);
          }
        })
        .catch((err) => console.log("err", err));
    } else {
      setDays([...days_arr]);
      setSelectedDays([]);
    }
  };

  const getDateList = (knf_company_site_id, ind) => {
    setOption(knf_company_site_id);
    if (knf_company_site_id?.value) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", knf_company_site_id?.value);
      post(URL.DATE_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [];
            let data = [...res?.data];
            data?.map((item, ind) => {
              let obj = {
                ...item,
                toggle: item?.status === 1,
                date: item?.for_date,
                for_date: moment(item?.for_date).format("DD-MM-YYYY"),
                start_time: item?.start_time
                  ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                  : "",
                end_time: item?.end_time
                  ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                  : "",
              };
              temp.push(obj);
            });
            setDates(temp);
            if (ind) {
              setSelectedDate(temp?.[ind]?.id);
            } else {
              setSelectedDate(temp?.[0]?.id);
            }
          } else {
            setDates([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setDates([]);
      setSelectedDate(null);
    }
  };

  useEffect(() => {
    if (type) {
      getDayList({ value: location?.state?.data?.id });
      getDateList({ value: location?.state?.data?.id });
    } else {
      getSiteList();
    }
  }, []);

  // const handleSubmit = (ind) => {
  //   let temp = [...days];
  //   let data = temp[ind];

  //   if (option?.value) {
  //     let arr = [data?.type, ...selectedDays];
  //     console.log("arrDataType", arr);
  //     let uniqueArr = [...new Set(arr)];
  //     console.log("uniqueArrType", uniqueArr);

  //     let payload = {
  //       knf_company_site_id: option?.value,
  //       type: uniqueArr,
  //       start_time: data?.start_time,
  //       end_time: data?.end_time,
  //     };
  //     console.log("payload", payload);
  //     // return;
  //     post(URL.SPECIAL_DAY_STORE, payload)
  //       .then((res) => {
  //         if (res?.status == "success") {
  //           toast.success(res?.message);
  //           getDayList(option);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("err", err);
  //       });
  //   } else {
  //     toast.error("Please select Site");
  //   }
  // };
  // const handleSubmit = (ind) => {
  //   if (!option?.value) {
  //     toast.error("Please select Site");
  //     return;
  //   }

  //   const currentDay = days[ind];

  //   // Calculate which days should be selected based on same time slot
  //   const matchingDays = days
  //     .filter(
  //       (d) =>
  //         d.type !== currentDay.type &&
  //         d.start_time === currentDay.start_time &&
  //         d.end_time === currentDay.end_time &&
  //         d.start_time &&
  //         d.end_time,
  //     )
  //     .map((d) => d.type);

  //   const payload = {
  //     knf_company_site_id: option.value,
  //     slots: days.map((day) => {
  //       const isCurrentDay = day.type === currentDay.type;
  //       const isCopiedDay = selectedDays.includes(day.type);

  //       return {
  //         type: day.type,
  //         start_time:
  //           isCurrentDay || isCopiedDay
  //             ? currentDay.start_time
  //             : day.start_time || "",
  //         end_time:
  //           isCurrentDay || isCopiedDay
  //             ? currentDay.end_time
  //             : day.end_time || "",
  //         status: isCurrentDay || isCopiedDay || day.toggle ? 1 : 0,
  //       };
  //     }),
  //   };

  //   console.log("daypayload", payload);

  //   post(URL.SPECIAL_DAY_STORE, payload)
  //     .then((res) => {
  //       if (res?.status === "success") {
  //         toast.success(res.message);
  //         getDayList(option, ind);

  //         // Update the days state with the new times
  //         const updatedDays = [...days];
  //         updatedDays[ind] = {
  //           ...updatedDays[ind],
  //           start_time: currentDay.start_time,
  //           end_time: currentDay.end_time,
  //           toggle: true,
  //         };

  //         // Also update any matching days with the same time slot
  //         matchingDays.forEach((dayType) => {
  //           const dayIndex = updatedDays.findIndex((d) => d.type === dayType);
  //           if (dayIndex !== -1) {
  //             updatedDays[dayIndex] = {
  //               ...updatedDays[dayIndex],
  //               start_time: currentDay.start_time,
  //               end_time: currentDay.end_time,
  //               toggle: true,
  //             };
  //           }
  //         });

  //         setDays(updatedDays);

  //         // IMPORTANT: Update selectedDays with the matching days
  //         setSelectedDays(matchingDays);

  //         // Refresh data from API
  //         getDayList(option);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //       toast.error(err?.message || "Something went wrong");
  //     });
  // };

  const handleSubmit = (ind) => {
    if (!option?.value) {
      toast.error("Please select Site");
      return;
    }

    const currentDay = days[ind];

    const payload = {
      knf_company_site_id: option.value,
      slots: days.map((day) => {
        const isCurrentDay = day.type === currentDay.type;
        const isCopiedDay = selectedDays.includes(day.type);

        return {
          type: day.type,
          start_time:
            isCurrentDay || isCopiedDay
              ? currentDay.start_time
              : day.start_time || "",
          end_time:
            isCurrentDay || isCopiedDay
              ? currentDay.end_time
              : day.end_time || "",
          status: isCurrentDay || isCopiedDay || day.toggle ? 1 : 0,
        };
      }),
    };

    post(URL.SPECIAL_DAY_STORE, payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res.message);

          // ✅ Only ONE getDayList call, with the current index
          getDayList(option, ind);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err?.message || "Something went wrong");
      });
  };

  const handleDateSubmit = (ind) => {
    let temp = [...dates];
    let data = temp[ind];
    let formdata = new FormData();
    // formdata.append("id", knf_company_site_id?.value);
    if (option?.value) {
      formdata.append("knf_company_site_id", option?.value);
      formdata.append("date", data?.date);
      formdata.append("start_time", data?.start_time);
      formdata.append("end_time", data?.end_time);
      post(URL.SPECIAL_DATE_STORE, formdata)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
            getDateList(option, ind);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please select Site");
    }
  };

  const sampleExcelDownload = () => {
    if (option?.value) {
      // get(URL.SAMPLE_DATE_EXCEL_DOWNLOAD)
      //   .then((res) => {})
      //   .catch((err) => {
      //     console.log("err", err);
      //   });

      try {
        const link = document.createElement("a");
        link.href = BASE_URL + URL.SAMPLE_DATE_EXCEL_DOWNLOAD;
        link.setAttribute("download", "");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log("error", error);
      }
    } else {
      toast.error("Please Select Site");
    }
  };

  const specialDateImport = () => {
    if (option?.value) {
      if (fileUpload?.name) {
        let formdata = new FormData();
        formdata.append("file", fileUpload);
        formdata.append("knf_company_site_id", option?.value);
        post(URL.SPECIAL_DATE_IMPORT, formdata)
          .then((res) => {
            if (res?.status == "success") {
              getDateList(option, 0);
              setFileUpload("");
              handleClose();
              if (res?.failed_rows?.length) {
                const groupedErrors = {};

                res.failed_rows.forEach((item) => {
                  const error = item.errors[0];

                  if (!groupedErrors[error]) {
                    groupedErrors[error] = [];
                  }

                  groupedErrors[error].push(item.row);
                });

                const message = Object.entries(groupedErrors)
                  .map(([error, rows]) => {
                    return `Rows ${rows.join(", ")}: ${error} other dates are imported succesufully`;
                  })
                  .join("\n\n");

                toast.error(message);
              } else {
                toast.success(res?.message);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        toast.error("Upload a File");
      }
    } else {
      toast.error("Please Select Site");
    }
  };

  const handleTabFun = (knf_company_site_id) => {
    // clear previous site data
    resetSlotStates();

    // set new selected site
    setOption(knf_company_site_id);

    // fetch new data
    getDayList(knf_company_site_id);
    getDateList(knf_company_site_id);
  };

  const resetSlotStates = () => {
    setDays([...days_arr]);
    setDates([]);
    setSelectedDate(null);
    setSelectedDays([]);
    setFileUpload("");
  };

  const { pathname } = useLocation();
  const permission = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );

  const companyViewAllowed =
    permission?.includes("CAN-View-KNF_COMPANY_ALERT_DAYS") &&
    pathname == "/company-slot";

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Schedule"} hide={true} />
      <div
        className={`d-flex w-100 justify-content-between align-item-center mt-2 mb-2 `}
      >
        <div
          className={`tab-header d-flex gap-3 mb-3 ms-4 ${!option?.value && "opacity-25"}`}
        >
          <button
            className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
            onClick={() => handleTab("week")}
          >
            Week days
          </button>
          <button
            className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
            onClick={() => handleTab("special")}
          >
            Special Holidays
          </button>
        </div>
        {!type && (
          <>
            {companyViewAllowed && (
              <div className="d-flex align-items-end justify-content-end flex-column ">
                <p
                  className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-2"
                  style={{ marginRight: "160px" }}
                >
                  Select Site
                </p>
                <SelectBox
                  arrayData={siteList}
                  selectedOption={option}
                  setSelectedOption={handleTabFun}
                  style={true}
                  width={"250px"}
                />
              </div>
            )}
          </>
        )}
      </div>

      {!option?.value && (
        <div
          className={`card shadow-sm border-0 rounded-4 mt-5 ${!option?.value && "opacity-25"}`}
        >
          <div className="card-body text-center py-5">
            <div className="mb-3">
              <div className="bg-light rounded-circle d-inline-flex p-4">
                <i className="bi bi-calendar-week fs-1 text-muted"></i>
              </div>
            </div>
            <h5 className="text-muted mb-2">No Slot days found</h5>
            <p className="text-muted small mb-0">
              Please select site to add/view/edit week and special days
            </p>
          </div>
        </div>
      )}

      <div>
        {activeTab == "week" && (
          <CompanySlotDays
            days={days}
            setDays={setDays}
            handleSubmit={handleSubmit}
            option={option}
            // type={type}
            handleCheckboxChange={handleCheckboxChange}
            selectedDays={selectedDays}
            getDayList={getDayList}
            getDateList={getDateList}
            setSelectedDays={setSelectedDays}
          />
        )}
        {activeTab == "special" && (
          <CompanySpecialSlot
            setShowPopup={setShowPopup}
            dates={dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setDates={setDates}
            handleDateSubmit={handleDateSubmit}
            option={option}
            getDateList={getDateList}
            // type={type}
          />
        )}
      </div>

      <Modal show={showPopup} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title> Import Excel</Modal.Title>
        </Modal.Header>
        <div className="p-3">
          <button
            className="text-start cust-btn rounded-3 bg-primar p-2 d-grid  text-white"
            onClick={() => sampleExcelDownload()}
          >
            Sample Download
          </button>
          <div className="mt-4">
            <h6>Upload Excel</h6>
            <input
              type="file"
              className="form-control w-100 mt-3"
              accept=".xlsx, .xls, .csv"
              onChange={(e) => {
                setFileUpload(e.target.files[0]);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end pt-2 mb-3 mx-5">
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={() => specialDateImport()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default CompanySlotMain;
